import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const VideoFeed = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const fetchVideos = async (q = '') => {
    setLoading(true);
    try {
      const res = await axios.get(`/api/videos/?q=${q}`);
      setVideos(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => { fetchVideos(); }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchVideos(search);
  };

  const formatDuration = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ color: '#fff', margin: 0 }}>🎬 XpertTube</h2>
        <button
          onClick={() => navigate('/videos/channel-apply')}
          style={{ background: '#0F6E56', color: '#000', border: 'none', borderRadius: '8px', padding: '10px 20px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          🎬 Start Your Channel
        </button>
      </div>

      <form onSubmit={handleSearch} style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search videos..."
          style={{ flex: 1, padding: '10px', borderRadius: '8px', border: 'none', background: '#1e2a3a', color: '#fff' }}
        />
        <button type="submit" style={{ background: '#0F6E56', color: '#000', border: 'none', borderRadius: '8px', padding: '10px 20px', fontWeight: 'bold', cursor: 'pointer' }}>
          Search
        </button>
      </form>

      {loading ? (
        <div style={{ color: '#aaa', textAlign: 'center', padding: '40px' }}>Loading...</div>
      ) : videos.length === 0 ? (
        <div style={{ color: '#aaa', textAlign: 'center', padding: '40px' }}>Koi video nahi mili</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
          {videos.map(v => (
            <div
              key={v.id}
              onClick={() => navigate(`/videos/${v.id}`)}
              style={{ background: '#1e2a3a', borderRadius: '12px', overflow: 'hidden', cursor: 'pointer' }}
            >
              <div style={{ position: 'relative' }}>
                {v.thumbnail_url ? (
                  <img src={v.thumbnail_url} alt={v.title} style={{ width: '100%', height: '160px', objectFit: 'cover' }} />
                ) : (
                  <div style={{ width: '100%', height: '160px', background: '#0d1b2a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '40px' }}>🎬</div>
                )}
                <span style={{ position: 'absolute', bottom: '8px', right: '8px', background: 'rgba(0,0,0,0.8)', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontSize: '12px' }}>
                  {formatDuration(v.duration)}
                </span>
              </div>
              <div style={{ padding: '12px' }}>
                <div style={{ color: '#fff', fontWeight: 'bold', marginBottom: '6px', fontSize: '14px' }}>{v.title}</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <span
                    onClick={(e) => { e.stopPropagation(); navigate(`/videos/channel/${v.uploader}`); }}
                    style={{ color: '#3ea6ff', fontSize: '12px', cursor: 'pointer', fontWeight: 'bold' }}>
                    @{v.uploader}
                  </span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', gap: '12px', color: '#aaa', fontSize: '12px' }}>
                    <span>👁 {v.views_count}</span>
                    <span>❤️ {v.likes_count}</span>
                    <span>💬 {v.comments_count}</span>
                  </div>
                  <button
                    onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(`${window.location.origin}/videos/${v.id}`); alert('Link copied!'); }}
                    style={{ background: 'none', border: '1px solid #444', color: '#aaa', borderRadius: '8px', padding: '4px 8px', cursor: 'pointer', fontSize: '11px' }}>
                    ↗ Share
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideoFeed;
